import HmEventRegistry from './../model/HmEventRegistry';
import HmAjax from './../util/HmAjax';
import NativeAjax from './../util/NativeAjax';
import UrlManager from './../model/UrlManager';
import RbUtil from './../util/RbUtil';

const PLPPrepPunchIn = function(){

	const contestGrpId = (() => {
		let contestId = localStorage.getItem("contestType");
		
		if(!contestId){
			try{
				contestId = window.location.pathname.substr(window.location.pathname.lastIndexOf("/")+1,window.location.pathname.length);
			}catch(e){
				console.error("Error while retrieving the contest grp Id", e);
			}			
		}

		return contestId;		
	})();

	let connectToPLP = (response) => {
		new NativeAjax(UrlManager.getUrlForAction("PLP_PREP_ACCESS_CHECK").replace("{#contestId}", contestGrpId)).enableCORS().mask().get((resp) => {
			if(resp && resp.status === "success"){
				//localStorage.setItem("loginVia",window.location.hostname);
				window.open(resp.url,"_blank");
			}else if(resp && resp.status !== "success"){
				let errMsg = (resp.errMsg) ? "prep.err." + resp.errMsg.toLowerCase() : null;
				promptError(errMsg);
			}else{
				//contest_in_progress
			}
		}, (err) => {
			promptError("503.msg","503","503.title");
			console.error("Error occurred :: ", err);
		});	
	}

	let promptError = (errMsg, statusCode,title) =>{
		let errObj = {
			"status_code":statusCode || "403",
			"msg": errMsg ? RbUtil.getText(errMsg) : RbUtil.getText("service.unavailable.yet"),
			"title": title
		};

		HmEventRegistry.fireEvent("ERROR_PROMPT",errObj);
	}
	
	let success = (resp) => {
		if(resp && resp.valid){
			connectToPLP(resp);
			//window.open(UrlManager.getUrlForAction("PREP_PUNCHIN_LUMOS").replace("{userId}",resp.uId),"_blank");
		}else if(resp && !resp.valid){
			let errMsg = (resp.errMsg) ? "prep.err." + resp.errMsg.toLowerCase() : null;
			promptError(errMsg);
		}else{
			//Do nothing now
		}
		
	}

	let failure = (err) => {
		promptError("503.msg","503","503.title");
		console.error("Error occurred :: ", err);
	}

	if(contestGrpId){
		new HmAjax(UrlManager.getUrlForAction("PREP_ACCESS_CHECK").replace("{#contestId}", contestGrpId)).mask().get(success, failure);	
	}else{
		console.error("contestGrpId not retrieved :: ", contestGrpId);
	}
}

export default PLPPrepPunchIn;

HmEventRegistry.registerEvent("plp_prep",function(){
	new PLPPrepPunchIn();
});


// WEBPACK FOOTER //
// ./src/vendors/PLPPrepPunchIn.js